'use client';
import { Controller, FieldErrors } from 'react-hook-form';
import "./style.css";

type Props = {
  label?: string;
  name: string;
  control: any;
  error?: string | FieldErrors;
  containerClassName?: string;
  className?: string;
  onlyNumber?: boolean;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
};

const ControlledTextArea = ({ label, name, control, error, containerClassName, className, onlyNumber, required, maxLength, disabled, placeholder }: Props) => {
  const getErrorMessage = (): string | undefined => {
    if (!error) return undefined;

    if (typeof error === "string") {
      return error;
    }

    // Navega pela estrutura aninhada de erros usando o caminho do name
    // Ex: "address.street" -> error.address.street
    if (typeof error === "object") {
      const nameParts = name.split(".");
      let currentError: any = error;

      for (const part of nameParts) {
        if (currentError && typeof currentError === "object" && part in currentError) {
          currentError = currentError[part];
        } else {
          return undefined;
        }
      }

      return currentError?.message as string | undefined;
    }

    return undefined;
  };

  const errorMessage = getErrorMessage();

  const handleValidation = (value: string) => {
    if (onlyNumber && !/^[0-9]*$/.test(value)) {
      return false;
    }
    return value;
  };

  return (
    <div className={`controlled-textarea-container ${containerClassName || ''}`}>
      {label && (
        <label htmlFor={name} className={`controlled-textarea-label ${errorMessage ? 'error' : ''}`}>
          {label}
          {required && <span className="controlled-textarea-required"> *</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <textarea
            id={name}
            className={`controlled-textarea-input ${errorMessage ? 'error' : ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
            value={value || ''}
            onChange={(e) => {
              const validatedValue = handleValidation(e.target.value);
              if (validatedValue !== false) {
                onChange(validatedValue);
              }
            }}
            maxLength={maxLength}
            disabled={disabled}
            placeholder={placeholder}
          />
        )}
      />
      {errorMessage && <small className="controlled-textarea-error">{errorMessage}</small>}
    </div>
  );
};

export default ControlledTextArea;
